import { render, staticRenderFns } from "./PhaseConfiguration.vue?vue&type=template&id=2fae3671"
import script from "./PhaseConfiguration.vue?vue&type=script&lang=js"
export * from "./PhaseConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports